import { render, staticRenderFns } from "./UploadPanel.vue?vue&type=template&id=e13f51de&scoped=true&"
import script from "./UploadPanel.vue?vue&type=script&lang=js&"
export * from "./UploadPanel.vue?vue&type=script&lang=js&"
import style0 from "./UploadPanel.vue?vue&type=style&index=0&id=e13f51de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e13f51de",
  null
  
)

export default component.exports